// extracted by mini-css-extract-plugin
export default {"productDescription":"w_-z","featuredDescription":"x_-z","description":"y_-z","more":"z_-z","descriptionSku":"A_-z"};